import * as All_EPSG from "epsg-index/all.json";

export interface EPSG_INdexData {
    accuracy: string | null;
    area: string;
    bbox: number[];
    code: string;
    kind: string;
    name: string;
    proj4: string;
    unit: string;
    wkt: string;
}

export const horizontalCRS = ['CRS-PROJCRS', 'CRS-GEOGCRS']
export const verticalCRS = ['CRS-VERTCRS']
export const compoundCRS = ['CRS-COMPOUNDCRS', 'CRS-GCENCRS', 'CRS-GEOG3DCRS']
export const ambiguousCRS = ['CRS-COMPOUNDCRS', 'CRS-DRVDCRS']

let allHorizontalCRS: string[] = []
allHorizontalCRS.push(...horizontalCRS)
allHorizontalCRS.push(...compoundCRS)
allHorizontalCRS.push(...ambiguousCRS)
allHorizontalCRS = Array.from(new Set(allHorizontalCRS))

let allVerticalCRS : string[] = []
allVerticalCRS.push(...verticalCRS)

let all_EPSG_Custom = JSON.parse(JSON.stringify(All_EPSG));

all_EPSG_Custom = Object.values(all_EPSG_Custom);

const verticalCRSList = all_EPSG_Custom.filter((epsg: any) => {
    let kind = epsg.kind;
    return allVerticalCRS.includes(kind);
});

const horizontalCRSList = all_EPSG_Custom.filter((epsg: any) => {
    let kind = epsg.kind;
    return allHorizontalCRS.includes(kind);
});

export default all_EPSG_Custom;
export { verticalCRSList, horizontalCRSList };